import React from 'react'
import Vendors from '../../../features/account-payable/vendor-management/Vendors'

const VendorManagementPage = () => {
  return (
    
    <Vendors/>
  )
}

export default VendorManagementPage